"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultAllowedCharsParams = exports.defaultAllowedChars = void 0;
exports.defaultAllowedChars = /(?:)/;
exports.defaultAllowedCharsParams = {
    mode: "key",
    onPaste: true,
};
